import React, { useState, useEffect } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

const ContactModal = ({ isOpen, contact, tags, onClose, onSave }) => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    city: '',
    state: '',
    source: 'manual',
    tags: [],
    notes: '',
    summary: '',
    potential_value: ''
  });

  useEffect(() => {
    if (isOpen) {
      if (contact) {
        setForm({
          name: contact.name || '',
          phone: contact.phone || '',
          email: contact.email || '',
          company: contact.company || '',
          city: contact.city || '',
          state: contact.state || '',
          source: contact.source || 'manual',
          tags: contact.tags || [],
          notes: '',
          summary: contact.summary || '',
          potential_value: contact.potential_value || ''
        });
      } else {
        setForm({ name: '', phone: '', email: '', company: '', city: '', state: '', source: 'manual', tags: [], notes: '', summary: '', potential_value: '' });
      }
    }
  }, [isOpen, contact]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      alert('Nome e telefone são obrigatórios');
      return;
    }
    const dataToSave = {
      ...form,
      potential_value: form.potential_value ? parseFloat(form.potential_value) : null
    };
    onSave(dataToSave);
  };

  const sourceOptions = [
    { value: 'manual', label: 'Manual' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'shopee', label: 'Shopee' },
    { value: 'indicacao', label: 'Indicação' },
    { value: 'site', label: 'Site' },
    { value: 'outro', label: 'Outro' }
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{contact ? 'Editar Contato' : 'Novo Contato'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4 max-h-[70vh] overflow-y-auto pr-2">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Nome *</label>
              <Input value={form.name} onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Telefone *</label>
              <Input value={form.phone} onChange={(e) => setForm(p => ({ ...p, phone: e.target.value }))} required />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">E-mail</label>
              <Input type="email" value={form.email} onChange={(e) => setForm(p => ({ ...p, email: e.target.value }))} />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Empresa</label>
              <Input value={form.company} onChange={(e) => setForm(p => ({ ...p, company: e.target.value }))} />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Cidade</label>
              <Input value={form.city} onChange={(e) => setForm(p => ({ ...p, city: e.target.value }))} />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">UF</label>
              <Input value={form.state} onChange={(e) => setForm(p => ({ ...p, state: e.target.value }))} maxLength={2} placeholder="RS" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Origem</label>
              <select
                value={form.source}
                onChange={(e) => setForm(p => ({ ...p, source: e.target.value }))}
                className="w-full h-10 px-3 border border-slate-200 rounded-lg"
              >
                {sourceOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          </div>
          
          {/* Summary - Key negotiation info */}
          <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
            <label className="block text-sm font-medium text-amber-800 mb-2">
              📋 Resumo da Negociação
            </label>
            <Textarea 
              value={form.summary} 
              onChange={(e) => setForm(p => ({ ...p, summary: e.target.value }))} 
              rows={2}
              placeholder="Ex: Interessado em 500 canecas personalizadas para evento corporativo em março..."
              className="bg-white"
            />
            <p className="text-xs text-amber-600 mt-1">Este resumo aparece diretamente no card para consulta rápida</p>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Valor Potencial (R$)</label>
            <Input 
              type="number" 
              step="0.01"
              value={form.potential_value} 
              onChange={(e) => setForm(p => ({ ...p, potential_value: e.target.value }))} 
              placeholder="Ex: 2500.00"
            />
          </div>
          
          {!contact && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Observação Inicial</label>
              <Textarea 
                value={form.notes} 
                onChange={(e) => setForm(p => ({ ...p, notes: e.target.value }))} 
                rows={2}
                placeholder="Adicione uma observação sobre este contato..."
              />
            </div>
          )}
          <div className="flex justify-end gap-2 pt-4 border-t">
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" className="bg-teal-600 hover:bg-teal-700 text-white">Salvar</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
